<template>
  <el-table :data="list" style="width: 100%" v-loading="loading" element-loading-text="数据加载中">
    <el-table-column type="expand">
      <template slot-scope="props">
        <el-form label-position="left" inline class="demo-table-expand">
          <el-form-item label="主体名称：">
            <span>{{props.row.principal_name}}</span>
          </el-form-item>
          <el-form-item label="模版：">
            <span v-if="props.row.weappTemplate.name">{{props.row.weappTemplate.name}}</span>
            <span v-else>未绑定小程序</span>
          </el-form-item>
          <el-form-item label="线上版本：">
            <span v-if="props.row.weappTemplate.version && props.row.weappTemplate.version == props.row.weapp.release_ver">最新版本</span>
            <span v-else-if="props.row.weapp.release_ver">{{props.row.weapp.release_ver}}</span>
            <span v-else>无</span>
          </el-form-item>
          <el-form-item v-if="props.row.weapp.reason && props.row.weapp.audit_status == '1'" label="审核失败原因：">
            <span>{{props.row.weapp.reason}}</span>
          </el-form-item>
        </el-form>
      </template>
    </el-table-column>
    <el-table-column label="小程序头像" width="120">
      <template slot-scope="img">
        <div v-if="img.row.head_img">
          <img :src="img.row.head_img" height="60"/>
        </div>
        <div v-else>
          <i class="iconfont icon-image fa-3x" aria-hidden="true"></i>
        </div>
      </template>
    </el-table-column>
    <el-table-column prop="authorizer_appid" label="小程序APPID"> </el-table-column>
    <el-table-column prop="nick_name" label="小程序名称">
      <template slot-scope="scope_name">
       <div v-if="scope_name.row.nick_name">
         {{scope_name.row.nick_name}}
       </div>
       <div v-else>
        未设置
       </div>
      </template>
    </el-table-column>
    <el-table-column prop="weappTemplate.name" label="小程序模版"> </el-table-column>
    <el-table-column label="小程序上架状态">
      <template slot-scope="verify_type_info">
        <el-tag v-if="verify_type_info.row.weapp.release_status == '1'" type="success">已上架</el-tag>

        <el-tag v-if="verify_type_info.row.weapp.audit_status == '1'" type="gray">审核失败</el-tag>
        <!--审核成功并且已经上架则不需要显示-->
        <el-tag v-else-if="verify_type_info.row.weapp.audit_status == '0' && verify_type_info.row.weapp.release_status != '1'" type="success">审核成功</el-tag>
        <el-tag v-else-if="verify_type_info.row.weapp.audit_status == '2'" type="primary">审核中</el-tag>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
  import { getTemplateList } from '@/api/template'
  import { getWxaAuthList, submitWxa } from '../../../api/wxa'
  export default {
    data () {
      return {
        loading: false,
        templateName: '',
        submitWeappForm: {
          wxaAppId: '',
          templateName: '',
          wxa_name: ''
        },
        templateList: [],
        list: []
      }
    },
    methods: {
      getWxaList () {
        this.loading = true
        getWxaAuthList().then(response => {
          this.list = response.data.data.list
          this.loading = false
        })
      }
    },
    mounted () {
      this.getWxaList()
      getTemplateList().then(response => {
        var res = response.data.data.list
        for (var i = 0; i < res.length; i++) {
          if (res[i].is_bind == false) {
            this.templateList.push(res)
          }
        };
      })
    }
  }
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 10px;
  .frm-tips {
    color: #8d8d8d;
  }
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.wxa-select {
  padding: 0 25px 25px;
}
.webchat-box {
  padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// index.vue?a4def526